import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";


// Thunk for getting Add banners
export const getPrivacy_Policy = createAsyncThunk(
    'home/add-privacy_policy',
    async (_, { rejectWithValue }) => {
        try {
            const privacypolicyData = await GET(API.GET_Privacy_Policy);
            return privacypolicyData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getShippingPolicy= createAsyncThunk(
    'home/add-shiiping_policy',
    async (_, { rejectWithValue }) => {
        try {
            const privacypolicyData = await GET(API.GET_Shipping_Policy);
            return privacypolicyData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Create the slice
const Slice = createSlice({
    name: "privacypolicy",
    initialState: {
        content: '',
        privacypolicies: [],
        shippingpolicies: [],
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(getPrivacy_Policy.pending, (state) => {
                state.status = 'loading';

            })
            .addCase(getPrivacy_Policy.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.privacypolicies = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(getPrivacy_Policy.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })

             .addCase(getShippingPolicy.pending, (state) => {
                state.status = 'loading';

            })
            .addCase(getShippingPolicy.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.shippingpolicies = action.payload?.data || [];
                console.log('State after fulfilled', state);
            })
            .addCase(getShippingPolicy.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                console.log('State after rejected', state);
            })


    },
});

export default Slice.reducer;


